module.exports = __webpack_public_path__ + "img/Important Bulletin.f0bdfc51.svg";